export const SensorOffset = {
  DEFAULT: 0,
};
export const SENSOR_NAME_DEPTH = 'DEPTH';
